/**
 * @generated SignedSource<<e2b0326709ea7929c384d1894f054add>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PackageDateEditFlight_data$data = {
  readonly " $fragmentSpreads": FragmentRefs<"PackageDateAddFlightDialog_data">;
  readonly " $fragmentType": "PackageDateEditFlight_data";
};
export type PackageDateEditFlight_data$key = {
  readonly " $data"?: PackageDateEditFlight_data$data;
  readonly " $fragmentSpreads": FragmentRefs<"PackageDateEditFlight_data">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PackageDateEditFlight_data",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PackageDateAddFlightDialog_data"
    }
  ],
  "type": "Query",
  "abstractKey": null
};

(node as any).hash = "f9fdbccd598c0e1422d6174f5e57fd32";

export default node;
